
import { MENU_DETAIL_FOOTER } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: MENU_DETAIL_FOOTER,
  props: ['count', 'price', 'cartMenuNo', 'appCartLength', 'riderInfo'],
  methods: {
    addCart () { this.$emit('addCart') },
    order () { this.$emit('order') }
  },
})
